module.exports = __webpack_public_path__ + "static/media/21ECLAC48.98763798.jpg";